import MidSessionConfigurationListing from "../../Components/Charging/MidSessionConfiguration";


export default function MidSessionConfigurationLists(){
    return(
        <MidSessionConfigurationListing />
    )
}